import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { EntityApi } from '../../sdk/services/custom';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from "lodash";

@Component({
  selector: 'formly-entity-selector',
  template: `
   <select [id]="id" [formControl]="formControl" class="form-control" [formlyAttributes]="field">
      <ng-template ngFor let-item [ngForOf]="optionValues">
       <option [value]="item.value">{{item.label}}</option>
    </ng-template>
    </select>
  `,
  providers: [EntityApi]
})
export class EntitySelect extends FieldType implements OnInit, OnDestroy {
  _loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
  optionValues = [];
  constructor(private _EntityApi: EntityApi) {
    super();
  }

  ngOnInit() {

    if (!this.form['subscriptions'])
      this.form['subscriptions'] = [];

    // Adding new Controls to hold formControls for hidden fields
    if (!this.form['newcontrols'])
      this.form['newcontrols'] = {};
    for (var key in this.form.controls) {
      this.form['newcontrols'][key] = this.form.controls[key];
    }

    // Load the drop down values    
    this._loopbackfilter.where = {};
    this._loopbackfilter.where["appId"] = this.model.appId;
    // console.log("Where Filter: " + JSON.stringify(this._loopbackfilter));

    //Get the entity records for the App
    this._EntityApi.find(this._loopbackfilter).subscribe((results) => {
      var items = [];
      if (results && results.length > 0) {
        for (var i = 0; i < results.length; i++) {
          items.push({ value: results[i]["id"], label: results[i]["label"] })
        }
      }
      this.optionValues = _.sortBy(items, 'label');
    });
  }

  ngOnDestroy() {
    this.optionValues = [];
  }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectentity.ts